
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 25","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.998 8.623v3.879m0 3.878h.01m9.687-3.878c0 5.355-4.342 9.697-9.697 9.697-5.356 0-9.697-4.342-9.697-9.697 0-5.356 4.341-9.697 9.697-9.697 5.355 0 9.697 4.341 9.697 9.697z","stroke":"currentColor","stroke-width":"1.939","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    